// extracted by mini-css-extract-plugin
export var container = "_ot-0";
export var dotAnimation = "_ot-2";
export var dotsLoading = "_ot-1";